import { graphql } from 'gatsby';
import { Button, Icon, IconType } from 'lucid-components-react';
import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel
} from 'react-accessible-accordion';

import {
  Drupal_ParagraphNineteenAccordionComponent,
  Drupal_ParagraphNineteenAccordionItem
} from '../../../generated/graphql';
import { isDefined } from '../../../types/types';
import { getProcessedValue } from '../../../utils/helpers';
import './nineteen-accordion.scss';

interface Props {
  entity: Drupal_ParagraphNineteenAccordionComponent;
  alignment: string;
}

const componentName = 'nineteen-accordion';
const NineteenAccordionComponent = ({
  entity: { fieldHeading, fieldItem, fieldExpandAllButton },
  alignment
}: Props) => {
  const [expandAllOpen, setExpandAllOpen] = useState(false);
  const [initialRender, setInitialRender] = useState(true);

  useEffect(() => {
    if (!initialRender) {
      Array.from(
        document.getElementsByClassName(`${componentName}__heading`)
      ).forEach(element => {
        // @ts-ignore
        element.click();
      });
    }
  }, [expandAllOpen]);

  useEffect(() => {
    setInitialRender(false);
  }, []);

  return (
    <section className={`${componentName}`}>
      <div
        className={`lucid-container lucid-container--flex ${componentName}--align-baseline`}
      >
        {fieldHeading && (
          <h2
            className={`${componentName}__title ${
              alignment === 'left'
                ? `${componentName}__title--left`
                : `${componentName}__title--center`
            }`}
          >
            {fieldHeading}
          </h2>
        )}

        {fieldExpandAllButton && (
          <div className="nineteen-accordion__spacer">
            <Button
              secondary
              asLink
              className={`${componentName}__trigger-icon`}
              onClick={() => {
                setExpandAllOpen(!expandAllOpen);
              }}
              type="button"
              data-ga-description={`${componentName}__expand-all`}
            >
              {expandAllOpen ? 'Close all' : 'Expand all'}
              <div
                className={`${componentName}__icon
                  ${
                    expandAllOpen
                      ? `${componentName}__icon--open`
                      : `${componentName}__icon--close`
                  }
                `}
              >
                <Icon type={IconType.CarotRight} color="#FFA056" />
              </div>
            </Button>
          </div>
        )}
        <Accordion
          className={`${componentName}__list`}
          allowZeroExpanded
          allowMultipleExpanded
        >
          {fieldItem &&
            fieldItem.filter(isDefined).map(({ entity }) => {
              const item = entity as Drupal_ParagraphNineteenAccordionItem;
              return (
                <AccordionItem
                  key={item.fieldNineteenAccordionItemHe!}
                  className={`${componentName}__item`}
                >
                  <AccordionItemHeading>
                    <AccordionItemButton
                      className={`${componentName}__heading callout-text`}
                    >
                      {item.fieldNineteenAccordionItemHe!}
                      <div className={`${componentName}__trigger-icon`}>
                        <Icon type={IconType.CarotRight} color="#FFA056" />
                      </div>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div
                      className={`${componentName}__text`}
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: getProcessedValue(
                          item.fieldNineteenAccordionItemBo
                        )
                      }}
                    />
                  </AccordionItemPanel>
                </AccordionItem>
              );
            })}
        </Accordion>
      </div>
    </section>
  );
};

export default NineteenAccordionComponent;

export const query = graphql`
  fragment nineteenAccordionComponent on Drupal_ParagraphNineteenAccordionComponent {
    fieldHeading
    fieldExpandAllButton
    fieldItem {
      entity {
        ... on Drupal_ParagraphNineteenAccordionItem {
          fieldNineteenAccordionItemHe
          fieldNineteenAccordionItemBo {
            processed
          }
        }
      }
    }
  }
`;
